<app-list-call-item-client
  [calls]="calls"
></app-list-call-item-client>

<div *ngIf="isLoading" fxFill fxLayoutAlign="center center">
  <mat-spinner diameter="30"></mat-spinner>
</div>

<mat-paginator
  fxFill
  itemsPerPageLabel="Items por página"
  [length]="length"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  (page)="setPage = $event"
></mat-paginator>
